import React from 'react';
import ButtonsModules from '../../commons/ButtonsModules';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import { Grid, Button, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import Ws from '../../providers/Ws';
import Utils from '../../providers/Utils';
import InsertBilantBalanta from '../../commons/dialogs/InsertBilantBalanta';
import BilanturiRows from '../../commons/dialogs/BilanturiRows';
import BalanteRows from '../../commons/dialogs/BalanteRows';
import FromServer from './FromServer';


export default class BalanteBilanturi extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listBalante: [],
            listBilanturi: [],
            isOpenIBalanta:false,
            isOpenIBilant:false,
            isOpenRBalanta:false,
            isOpenRBilant:false,
            objRowsBilant:{descriere:'',
                    id_head:'',
                    obs:'',
                    nr_crt:'',
                    nr_rd:'',
                sold_initial:0,
                sold_final:0},
                objRowsBalanta:{
                    id_head:'',
                    simbol:'',
                    denumire:'',
                    sidebit:'',
                    sicredit:'',
                    rdebit:'',
                    rcredit:'',
                    tsdebit:'',
                    tscredit:'',
                    sfdebit:'',
                    sfcredit:''
                },    
            listRowsBilanturi:[],
            listRowsBalante:[],    
            luna:'',
            nrYear:'',
            listYears: new Utils().getLast10Years(),
                listMonths: new Utils().getMonths,
                idBilant:0,
                idBlanata:0
        }
    }

    componentDidMount() {
        this.getBalanteBilanturi()
        this.props.goToBilant(this.openBilantRows)
        this.props.goToBalanta(this.openBalantaRows)
    }


    getBalanteBilanturi = async () => {

      

        let fs = new FromServer()

        let getData = await fs.getBalanteBilanturi()

        // console.log('getData :', getData);

        if(getData.r){
            this.setState({
                listBalante: getData.c.balante,
                listBilanturi: getData.c.bilanturi
            })
        }

  
        
        

    }

    changeObjBilant= n=>ev=>{
        let cloneObj = {...this.state.objRowsBilant}

        cloneObj[n] = ev.target.value

        this.setState({objRowsBilant:cloneObj})
    }

    changeObjBalanta= n=>ev=>{
        let cloneObj = {...this.state.objRowsBalanta}

        cloneObj[n] = ev.target.value

        this.setState({objRowsBalanta:cloneObj})
    }

    getBalanteRows= async()=>{
        
        let fs = new FromServer()

        let getRows = await fs.getBalanteRows(this.state.objRowsBalanta.id_head)

        if(getRows.r){
  
                this.setState({listRowsBalante:getRows.c})
          
        }
    

      
    }

    getBilanturiRows= async()=>{
        
        let fs = new FromServer()

        let getRows = await fs.getBilanturiRows(this.state.objRowsBilant.id_head)
     

        if(getRows.r ){
            this.setState({listRowsBilanturi:getRows.c})
        }
    }

    openBilantRows = (t) =>{
        let cloneRows= {...this.state.objRowsBilant}

        cloneRows.id_head = t.id
        this.setState({isOpenRBilant:true,
                        objRowsBilant:cloneRows},()=>{
                            this.getBilanturiRows()
                        })
    }

    openBalantaRows = (t) =>{

        // console.log('t :', t);
        let cloneRows= {...this.state.objRowsBalanta}

        cloneRows.id_head = t.id
        this.setState({isOpenRBalanta:true,
                        objRowsBalanta:cloneRows},()=>{
                            this.getBalanteRows()
                        })
    }


    addRowBilant = async() =>{

        let fs = new FromServer();

        let insertRow = await fs.addRowBilant(this.state.objRowsBilant);

        if(insertRow.r){
            this.getBilanturiRows()
        }
    }

    addRowBalanta = async() =>{
        let fs = new FromServer()

        let insertRow = await fs.addRowBalanta(this.state.objRowsBalanta)

        if(insertRow.r){
            this.getBalanteRows()
        }
    }

    deleteRowBilant = async(r)=>{
        // console.log('r :', r);

     let fs = new FromServer();

     let deleteRowBilant = await fs.deleteRowBilant({sters:1}, {id:r.id})

        if(deleteRowBilant.r){
            this.getBilanturiRows()
        }

    }

    deleteRowBalanta = async(r)=>{
        // console.log('r :', r);

      let fs = new FromServer();

    let deleteRowBalanta =await fs.deleteRowBalanta({sters:1}, {id:r.id})

        if(deleteRowBalanta.r){
            this.getBalanteRows()
        }

    }
    render() {
        return (
            <div>
              



               

                    <BilanturiRows
                        open={this.state.isOpenRBilant}
                        dialogClose={()=>{this.setState({isOpenRBilant:false})}}
                        strNume={'Adauga Coloana Bilant'}
                        objRows={this.state.objRowsBilant}
                        changeObj={this.changeObjBilant}
                        listRows={this.state.listRowsBilanturi}
                        limba={this.dictionary}
                        addRow={this.addRowBilant}
                        deleteRow={this.deleteRowBilant}
                        />

                        <BalanteRows
                            open={this.state.isOpenRBalanta}
                            dialogClose={()=>{this.setState({isOpenRBalanta:false})}}
                            strNume={'Adauga Coloana Balanta'}
                            objRows={this.state.objRowsBalanta}
                            changeObj={this.changeObjBalanta}
                            listRows={this.state.listRowsBalante}
                            limba={this.dictionary}
                            addRow={this.addRowBalanta}
                            deleteRow={this.deleteRowBalanta}
                            />


                <Divider className='pm-divider' />

                <Grid style={{ width: '90%', margin: 'auto' }} container>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <h3 style={{ textAlign: 'center' }} className='pm-title'>{this.dictionary.financiarContabil.balante}
                            {/* <Button
                            onClick={()=>{this.setState({isOpenIBalanta:true})}}
                                style={{
                                    width: 'fit-content',
                                    marginLeft: 10,
                                    color: 'white',
                                    backgroundColor: '#2cb7e0'
                                }} variant="contained"><i className='material-icons'>add</i></Button> */}
                        </h3>

                        {this.state.listBalante.length > 0 &&

                            <Table style={{width:'90%', margin:'auto'}}>
                                <TableHead>
                                    <TableRow style={{}}>

                                        <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                            An
                               </TableCell>
                                        <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                            Luna
                               </TableCell>


                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {this.state.listBalante.map((l, idx) => {
                                        return (
                                            <TableRow onClick={()=>{this.openBalantaRows(l)}} style={{cursor:'pointer'}} key={idx}>
                                                <TableCell style={{ textAlign: 'center' }}>
                                                    {l.an}
                                                </TableCell>

                                                <TableCell style={{ textAlign: 'center' }} >
                                                    {l.luna}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        }


                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <h3 style={{ textAlign: 'center' }} className='pm-title'>{this.dictionary.financiarContabil.bilanturi}
                            {/* <Button
                            onClick={()=>{this.setState({isOpenIBilant:true})}}
                                style={{
                                    width: 'fit-content',
                                    marginLeft: 10,
                                    color: 'white',
                                    backgroundColor: '#2cb7e0'
                                }} variant="contained"><i className='material-icons'>add</i></Button> */}
                        </h3>


                        {this.state.listBilanturi.length > 0 &&

                            <Table style={{width:'90%', margin:'auto'}}>
                                <TableHead>
                                    <TableRow >

                                        <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                            An
                               </TableCell>
                                        <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                            Luna
                               </TableCell>


                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {this.state.listBilanturi.map((l, idx) => {
                                        return (
                                            <TableRow onClick={()=>{this.openBilantRows(l)}} style={{cursor:'pointer'}} key={idx}>
                                                <TableCell style={{ textAlign: 'center' }}>
                                                    {l.an}
                                                </TableCell>

                                                <TableCell style={{ textAlign: 'center' }} >
                                                    {l.luna}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        }
                    </Grid>


                </Grid>
            </div>
        );
    }
}